import React from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { trackBookCall } from "@/lib/analytics";

const BOOKING_URL = process.env.REACT_APP_BOOKING_URL;

// Secondary conversion path. Uses an external scheduling link when
// REACT_APP_BOOKING_URL is configured; otherwise routes to the contact page.
export default function BookCallButton({ location = "hero", className = "", label = "Book a 15-Minute Call", size = "lg" }) {
  const pad = size === "lg" ? "px-7 py-4" : "px-7 py-3.5";
  const cls = `inline-flex items-center justify-center gap-2 rounded-md border border-white/25 ${pad} text-base font-semibold text-white transition-colors hover:bg-white/10 ${className}`;
  const onClick = () => trackBookCall(location);
  if (BOOKING_URL) {
    return (
      <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" onClick={onClick} className={cls} data-testid="book-call-btn">
        <CalendarClock className="h-5 w-5" aria-hidden="true" /> {label}
      </a>
    );
  }
  return (
    <Link to="/contact" onClick={onClick} className={cls} data-testid="book-call-btn">
      <CalendarClock className="h-5 w-5" aria-hidden="true" /> {label}
    </Link>
  );
}
